

















































































































































































import {
  defineComponent,
  toRefs,
  computed,
  PropType,
  ref,
  useRouter,
  useRoute,
  useFetch,
  onMounted,
  onUnmounted
} from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { HierarchicalCategory } from '~/models/category/types'
import HierarchicalCategoryService from '~/services/category/HierarchicalCategoryService'
import { useDep } from '~/compositions/dependency-container'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import { useStatic } from '~/compositions/useStatic'
import { useNamespacedStore } from '~/compositions/store'
import XymaCatImg from './XymaCatImg.vue'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import MobileSideBarFooter from '../classifieds/search/mobile/MobileSideBarFooter.vue'
import SearchService from '~/services/search/SearchService'
import qs from 'qs'
import { ciTimes } from '~/icons/source/regular/times'
import { ciHistory } from '~/icons/source/regular/history'
import {
  RESET_ROW_RESULTS,
  SET_LOADING_FACETS
} from '~/store/modules/shared/classifieds/search/mutation-types'
import { capitalizeSentences } from '~/utils/string'
import { formatNumber } from '~/utils/number'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: {
    CImg,
    XymaCatImg,
    Searchbar,
    MobileSideBarFooter
  },
  props: {
    subTreeCategories: {
      type: Array as PropType<HierarchicalCategory[]>,
      default: () => []
    },
    topLevelId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { getters, dispatch, commit, state } = useNamespacedStore<
      SearchState
    >(CLASSIFIED_SEARCH_NS)
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const s = useStatic()
    const { tc } = useI18n()
    const searchService = useDep(SearchService)
    const hierarchicalCategoryService = useDep(HierarchicalCategoryService)
    const { subTreeCategories } = toRefs(props)

    const router = useRouter()
    const route = useRoute()
    const subCategories = ref<HierarchicalCategory[]>([])
    const isSubCategorySelected = ref(false)
    const selectedTopCategory = ref('')
    const selectedSubCategory = ref('')
    const selectedCategoryName = ref('')
    const ancestorHumanName = ref<string[]>([])
    const ancestorIds = ref<string[]>([])

    const isPc = computed(() => userAgentGetters('isPc'))
    const filteredCategories = computed(() =>
      subTreeCategories.value.filter(
        cat => !['14600', '2933', '2928'].includes(cat.id)
      )
    )
    const targetSeoUrl = computed(() => getters('getTargetSeoUrl'))
    const loadingFacets = computed(() => state.loading.facets)
    const totalRows = computed(() => state.stats?.total)

    const icons = {
      faArrowLeft: faAngleLeft,
      close: ciTimes,
      history: ciHistory
    }

    useFetch(async () => {
      await fetchForCategory(process.server)
    })

    const computedBg = (id: string) => {
      switch (id) {
        case '2915':
          return '#7ACCEB'
        case '2921':
          return '#eab792'
        case '2914':
          return '#f19898'
        case '2920':
          return '#5bbc6a'
        case '2911':
          return '#71b09d'
        case '4112':
          return '#889fb6'
        case '3909':
          return '#f4d14d'
        case '3581':
          return '#AEC2E0'
        case '4723':
          return '#cfb89c'
        case '3726':
          return '#2f82bf'
        case '3220':
          return '#e55e5c'
      }
    }

    const computedCategoryImgUrl = computed(() => {
      switch (selectedTopCategory.value) {
        case '2915':
          return s(
            '/nuxt-static/img/quick-search/1-mikres-aggelies-texnologia.png'
          )
        case '2921':
          return s(
            '/nuxt-static/img/quick-search/2-mikres-aggelies-spiti-kipos.png'
          )
        case '2914':
          return s('/nuxt-static/img/quick-search/3-mikres-aggelies-moda.png')
        case '2920':
          return s(
            '/nuxt-static/img/quick-search/4-mikres-aggelies-athlitismos-hobbie.png'
          )
        case '2911':
          return s(
            '/nuxt-static/img/quick-search/5-mikres-aggelies-epixeirhseis-eksoplismos.png'
          )
        case '4112':
          return s(
            '/nuxt-static/img/quick-search/6-mikres-aggelies-eksoplismos-mazikis-estiashs.png'
          )
        case '3909':
          return s(
            '/nuxt-static/img/quick-search/7-mikres-aggelies-ergaleia-accessories.png'
          )
        case '3581':
          return s(
            '/nuxt-static/img/quick-search/8-mikres-aggelies-paidika-vrefika.png'
          )
        case '4723':
          return s(
            '/nuxt-static/img/quick-search/9-mikres-aggelies-antikes.png'
          )
        case '3726':
          return s(
            '/nuxt-static/img/quick-search/10-mikres-aggelies-ygeia-omorfia.png'
          )
        case '3220':
          return s(
            '/nuxt-static/img/quick-search/11-mikres-aggelies-supermarket.png'
          )

        default:
          return null
      }
    })

    const handleSmallClassifiedsTopCategorySelection = async (
      {
        id,
        humanName
      }: {
        id: string
        humanName: string
      },
      updateUrl: boolean = true
    ) => {
      selectedTopCategory.value = id
      await fetchSmallClassifiedsSubcategories(id, updateUrl)
      isSubCategorySelected.value = true
      ancestorIds.value = subCategories.value[0].ancestorIds
      selectedCategoryName.value = humanName
    }

    const handleSmallClassifiedsSubCategorySelection = async (
      {
        id,
        childrenCanBeRetrieved,
        humanName
      }: {
        id: string
        childrenCanBeRetrieved?: boolean
        humanName: string
      },
      showNext = true,
      updateUrl: boolean = true
    ) => {
      if (childrenCanBeRetrieved) {
        await fetchSmallClassifiedsSubcategories(id, updateUrl)
        ancestorIds.value = subCategories.value[0].ancestorIds
        if (showNext) {
          ancestorHumanName.value.push(selectedCategoryName.value)
        }
        selectedCategoryName.value = humanName
      } else {
        handleRedirect(id)
      }
    }

    const fetchSmallClassifiedsSubcategories = async (
      id: string,
      updateUrl = true
    ) => {
      selectedSubCategory.value = id
      const response = await hierarchicalCategoryService.getCategoryMap(id, +id)
      subCategories.value = []
      Array.from(response).reduce((acc: any, cur: any) => {
        acc.push(cur[1])
        return acc
      }, subCategories.value)

      await handleRoutingAndSearchResults(id, updateUrl)
    }

    const handleRedirect = (id: string) => {
      router.push({
        path: targetSeoUrl.value,
        query: {
          ca: id
        }
      })
    }

    const handleRoutingAndSearchResults = async (
      id: string,
      updateUrl = true
    ) => {
      const resolvedRoute = router.resolve({
        name: '__classifieds_quick_search',
        params: {
          root: 'xyma'
        },
        query: {
          category: id === '50' ? undefined : id
        }
      }) as any

      let routeToUse = router.resolve({
        name: '__classifieds_quick_search',
        query: {
          root: '50',
          category: id
        }
      }).route as any

      if (process.client && window) {
        updateUrl && (await dispatch('updateUrl', resolvedRoute.href))

        routeToUse = {
          fullPath: window.location.pathname + window.location.search,
          // @ts-ignore
          query: {
            root: '50',
            category: id
          },
          path: window.location.pathname,
          name: '__classifieds_quick_search'
        }
      }

      await searchService.createSearch({
        route: routeToUse,
        mapSearch: false,
        errorFn: () => {},
        isQuickSearch: true
      })
    }

    const goBack = () => {
      if (!isSubCategorySelected.value) return

      if (ancestorIds.value[1] === '50') {
        selectedCategoryName.value = ''
        isSubCategorySelected.value = false
        selectedSubCategory.value = ''
        ancestorHumanName.value = ['']
        selectedTopCategory.value = ''
        handleRoutingAndSearchResults('50')
      }

      if (selectedSubCategory.value) {
        handleSmallClassifiedsSubCategorySelection(
          {
            id: ancestorIds.value[1],
            childrenCanBeRetrieved: true,
            humanName:
              ancestorHumanName.value[ancestorHumanName.value.length - 1]
          },
          false
        )
        ancestorHumanName.value.pop()
      }
    }

    const handleShowClassifiedsButtonClick = () => {
      commit(RESET_ROW_RESULTS)
      commit(SET_LOADING_FACETS, true)
      router.push({ path: targetSeoUrl.value })
    }

    function addEventListeners() {
      window.addEventListener('popstate', handlePopState, false)
    }

    function removeEventListeners() {
      window.removeEventListener('popstate', handlePopState)
    }

    async function handlePopState(event: any) {
      if (!event?.state) {
        return
      }

      if (!event.state.isInSearchPage) {
        if (event.state.resetSearchState) {
          window.history.replaceState(
            { isInSearchPage: true },
            '',
            window.location.href
          )
        }
        return
      }
      if (event.state.isQuickSearch) {
        await fetchForCategory(false)
      }
    }

    async function fetchForCategory(updateUrl = true) {
      let cat = route.value.query.category

      if (process.client) {
        const { category } = qs.parse(window.location.search, {
          ignoreQueryPrefix: true
        })
        cat = category as string
      }

      if (!cat) {
        selectedCategoryName.value = ''
        isSubCategorySelected.value = false
        selectedSubCategory.value = ''
        ancestorHumanName.value = ['']
        selectedTopCategory.value = ''

        // await handleRoutingAndSearchResults('50', updateUrl)

        return
      }

      const response = await hierarchicalCategoryService.getCategoryMap(
        cat.toString(),
        50
      )

      const category = response.get(cat.toString())

      if (category?.parentId === '50') {
        await handleSmallClassifiedsTopCategorySelection(
          {
            id: cat.toString() || '',
            humanName: category.humanName || ''
          },
          updateUrl
        )
      } else {
        await handleSmallClassifiedsTopCategorySelection(
          {
            id: category?.ancestorIds[category?.ancestorIds.length - 3] || '',
            humanName: ''
          },
          updateUrl
        )

        await handleSmallClassifiedsSubCategorySelection(
          {
            id: category?.id || '',
            childrenCanBeRetrieved: true,
            humanName: category?.humanName as string
          },
          true,
          updateUrl
        )
      }

      ancestorIds.value = category!.ancestorIds
      ancestorIds.value.unshift(cat.toString())

      const array: string[] = []

      ancestorIds.value.forEach(v => {
        const r = response.get(v)
        array.push(r?.humanName as string)
      })

      array.reverse()
      array.splice(0, 2)
      array.splice(-1, 1)
      array.unshift('')

      ancestorHumanName.value = array

      selectedSubCategory.value = cat.toString()
    }

    onMounted(() => {
      window.history.replaceState(
        { isInSearchPage: true, isQuickSearch: true },
        '',
        window.location.href
      )
      addEventListeners()
    })
    onUnmounted(() => {
      removeEventListeners()
    })

    const resultsText = computed(() => {
      return capitalizeSentences(
        tc(
          'show 1 classified | show {count} classifieds',
          formatNumber(totalRows.value!) as any
        )
      )
    })

    return {
      filteredCategories,
      selectedSubCategory,
      subCategories,
      computedBg,
      icons,
      isSubCategorySelected,
      selectedCategoryName,
      handleSmallClassifiedsTopCategorySelection,
      handleSmallClassifiedsSubCategorySelection,
      goBack,
      handleShowClassifiedsButtonClick,
      isPc,
      computedCategoryImgUrl,
      selectedTopCategory,
      ancestorIds,
      ancestorHumanName,
      loadingFacets,
      resultsText
    }
  }
})
